<template>
  <div 
    v-if="thereAreFilters" 
    class="filter-breadcrumbs"
  >
    <!-- <p
      v-if="thereAreFilters"  
      class="recipe-counts"
    >
      {{ itemCount }} {{ itemType(view) }}
    </p> -->
    <div class="filtered-by">
      Filtered by:
    </div>
    <div
      v-if="thereAreFilters"
      class="filtered-categories"
    >
      <template
        v-for="(filt, index) in filterCategories"
      >
        <fieldset
          :key="index"
        >
          <button
            :id="filt.id"
            type="button"
            class="toggle active"
            :value="filt.id"
            :name="filt.name"
            @click="updateFilters(filt.id)"
          >
            {{ filt.name }}<span class="close-icon"> &times;</span>
          </button>
        </fieldset>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: "FilterBreadcrumbs",
  props: {
    view: {
      type: String,
      required: true,
      default: 'Recipes'
    }
  },
  computed: {
    filterCategories: function() {
      var categories = [];
      this.$store.state.filters.map(f => {
        if(f.selected === true){
          categories.push(f);
        }
      })
      return categories;
    },
    filteredItems: function() {
      return this.$store.state.items.filter(i => {
        // console.log(i);
        return !i.isExcluded;
      })
    },
    itemCount: function() {
      return this.filteredItems.length;
    },
    thereAreFilters: function() {
      return this.filterCategories.length !== 0
    }
  },
  methods: {
     itemType: function(e){
       console.log(this.itemCount)
       console.log(e)
      if ( this.itemCount === 1 && e === 'products'){
        return 'Product'
      } else if (this.itemCount === 1 && e === 'recipe'){
        return 'Recipe'
      } else if ( this.itemCount !== 1 && e === 'products'){
        return 'Products'
      } else if (this.itemCount !== 1 && e === 'recipe'){
        return 'Recipes'
      } else {
        return 'Items'
      }
    },
    updateFilters: function(e) {
        let payload = {
            checked: false,
            value: e
        }
    this.$store.dispatch('applyFilters', payload)
    this.$emit('remove', payload)
    }
  }

}
</script>